import { render, staticRenderFns } from "./gallery-dialog.vue?vue&type=template&id=32842650&scoped=true&"
import script from "./gallery-dialog.vue?vue&type=script&lang=js&"
export * from "./gallery-dialog.vue?vue&type=script&lang=js&"
import style0 from "./gallery-dialog.vue?vue&type=style&index=0&id=32842650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32842650",
  null
  
)

export default component.exports